export default "__VITE_ASSET__DA9sDgte__"